
import React from 'react';
import { Checkbox } from "@/components/ui/checkbox";

interface CheckboxGroupProps {
  items: {
    id: string;
    label: string;
  }[];
  value: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ 
  items, 
  value = [], 
  onChange, 
  disabled = false 
}) => {
  const handleCheckChange = (itemId: string, checked: boolean) => {
    if (checked) {
      onChange([...value, itemId]);
    } else {
      onChange(value.filter(id => id !== itemId));
    }
  };

  return (
    <div className="grid grid-cols-2 gap-2">
      {items.map(item => (
        <div key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
          <Checkbox
            id={`checkbox-${item.id}`}
            checked={value.includes(item.id)}
            onCheckedChange={(checked) => handleCheckChange(item.id, !!checked)}
            disabled={disabled}
          />
          <label 
            htmlFor={`checkbox-${item.id}`}
            className="font-normal text-sm cursor-pointer"
          >
            {item.label}
          </label>
        </div>
      ))}
    </div>
  );
};
